import { BrowserPhoneState } from "./telephonyTypes";

export const ACTIVE_CALL_STATES = new Set([
  BrowserPhoneState.INCOMING_CALL,
  BrowserPhoneState.INCOMING_CONNECTING,
  BrowserPhoneState.OUTGOING_CALL,
  BrowserPhoneState.ACTIVE_CALL,
  BrowserPhoneState.HOLD,
]);

export const isActiveCallState = (state) => ACTIVE_CALL_STATES.has(state);
